import React, {useState} from 'react';

/**
 * Поле пароля с переключателем видимости.
 *
 * Общий компонент на оба места ввода пароля — вход/регистрацию по почте и
 * задание нового пароля по ссылке из письма: поведение у них одинаковое, а
 * две копии разошлись бы при первой же правке.
 *
 * Значок показывает ДЕЙСТВИЕ, а не состояние: пока пароль скрыт, нарисован
 * открытый глаз («показать»), а когда виден — перечеркнутый («скрыть»). Так
 * устроено большинство форм, и человек не гадает, что означает картинка.
 */
function PasswordInput({
  value,
  onChange,
  placeholder = 'Пароль',
  autoComplete = 'current-password',
  disabled,
  autoFocus,
}) {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="password-input">
      <input
        className="email-auth-input password-input_field"
        type={isVisible ? 'text' : 'password'}
        autoComplete={autoComplete}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={autoFocus}
      />
      <button
        // Кнопка внутри формы без явного типа отправляла бы форму
        type="button"
        className="password-input_toggle"
        onClick={() => setIsVisible((previous) => !previous)}
        // Поле не должно терять фокус: иначе после переключения человеку
        // приходится заново попадать в него, чтобы дописать пароль
        onMouseDown={(event) => event.preventDefault()}
        aria-label={isVisible ? 'Скрыть пароль' : 'Показать пароль'}
        title={isVisible ? 'Скрыть пароль' : 'Показать пароль'}
        tabIndex={-1}
      >
        <img
          className="password-input_icon"
          src={isVisible ? '/img/icons/hidden.png' : '/img/icons/view.png'}
          alt=""
        />
      </button>
    </div>
  );
}

export default PasswordInput;
